// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"fGDZTs","hidden":"iOl2Sm","clampContainer":"ZrPd54","clamp":"_3D2li2"};